import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import FileUploader from '../components/FileUploader';
import { buildFormData } from '../utils/fileUpload';
import '../styles/formPage.css';

function BoardWrite() {
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [images, setImages] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('userInfo')) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return alert('제목을 입력해주세요.');
    if (!content.trim()) return alert('내용을 입력해주세요.');

    try {
      setLoading(true);
      const formData = buildFormData({ title: title.trim(), content: content.trim() }, { images, attachments });
      const res = await API.post('/board', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (res.data?.success === false) {
        alert(res.data.message || '등록에 실패했습니다.');
        return;
      }
      alert('게시글이 등록되었습니다.');
      navigate('/board', { replace: true });
    } catch (error) {
      alert(`오류가 발생했습니다: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (window.confirm('작업을 취소하시겠습니까? 작성한 내용이 삭제됩니다.')) navigate('/board', { replace: true });
  };

  return (
    <div className="form-page container container--narrow section">
      <div className="form-page__head">
        <span className="section__eyebrow">Board</span>
        <h1 className="form-page__title">게시글 작성</h1>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="field">
          <label className="field__label" htmlFor="title">제목 <span className="req">*</span></label>
          <input id="title" className="input" type="text" value={title}
            onChange={(e) => setTitle(e.target.value)} placeholder="제목을 입력하세요" disabled={loading} />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="content">내용 <span className="req">*</span></label>
          <textarea id="content" className="textarea" value={content}
            onChange={(e) => setContent(e.target.value)} placeholder="내용을 입력하세요" disabled={loading} />
        </div>

        <FileUploader id="images" label="이미지 업로드" accept="image/*" image
          files={images} onChange={setImages} disabled={loading} />

        <FileUploader id="attachments" label="첨부파일 업로드"
          files={attachments} onChange={setAttachments} disabled={loading} />

        <div className="form-actions">
          <button type="button" className="btn btn--ghost" onClick={handleCancel} disabled={loading}>취소</button>
          <button type="submit" className="btn btn--primary" disabled={loading}>
            {loading ? '등록 중...' : '등록'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default BoardWrite;
